import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  > * {
    flex: 1;
    min-width: 0;
  }
`
